import { render, staticRenderFns } from "./ChipGroupGender.vue?vue&type=template&id=67e0bc94&"
import script from "./ChipGroupGender.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ChipGroupGender.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67e0bc94')) {
      api.createRecord('67e0bc94', component.options)
    } else {
      api.reload('67e0bc94', component.options)
    }
    module.hot.accept("./ChipGroupGender.vue?vue&type=template&id=67e0bc94&", function () {
      api.rerender('67e0bc94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/ChipGroupGender/ChipGroupGender.vue"
export default component.exports